export default __webpack_public_path__ + "static/media/profile.4438e506.png";